import Webcam from "react-webcam";

import { useRef, useState, useCallback } from "react"; // import useRef
import PropTypes from "prop-types";
import {
  // Grid,
  Icon,
  // FormControl,
  // InputLabel,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Grid,
  Snackbar,
  Alert,
  Button,
  Box,
  Typography,
  InputAdornment,
  IconButton,
} from "@mui/material";
// import Input from "theme/components/Input";

function DocumentField({ displayName, fieldRef, options }) {
  const [fieldError, showFieldError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const webcamRef = useRef(`${fieldRef}_${displayName}`); // create a webcam reference
  const [imgSrc, setImgSrc] = useState(null);
  const [capturedImg, setCapturedImg] = useState(null);
  const [cameraUsed, setCameraUsed] = useState(false);
  const [uploadType, setUploadType] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const placeholderImg =
    "data:image/jpeg;base64,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";

  const videoConstraints = {
    facingMode: cameraUsed ? "user" : { exact: "environment" },
  };

  const [openWebCamDialog, setOpenWebCamDialog] = useState(false);

  // create a capture function
  const capture = useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (!imageSrc) {
      setErrorMsg("No photo image found.");
      showFieldError(true);
      return;
    }

    setImgSrc(imageSrc);
    setCapturedImg(imageSrc);
    setOpenWebCamDialog(false);
  }, [webcamRef]);

  async function toBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });
  }

  async function handleFileChange(event) {
    const file = event.target.files[0];
    const fileKb = Math.round(file.size / 1024);
    if (fileKb > 5000) {
      setErrorMsg("File size cannot exceed 5MB.");
      showFieldError(true);
      return;
    }

    await toBase64(file)
      .then((res) => {
        if (
          res.startsWith("data:image/heic;base64") ||
          res.includes("data:image/heic;base64")
        ) {
          setErrorMsg(
            "File format not supported. Recommended image formats: JPEG, JPG, PNG"
          );
          showFieldError(true);
          return;
        }

        setSelectedFile(res);
      })
      .catch((err) => {
        console.log(err);
        setErrorMsg(err);
        showFieldError(true);
        return;
      });
  }

  return (
    <Box>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openWebCamDialog}>
        <DialogTitle>
          <Box>Scan {displayName}</Box>
        </DialogTitle>
        <DialogContent>
          <Box mt={2} mb={3}>
            <Webcam
              // height={"100%"}
              width="100%"
              ref={webcamRef}
              screenshotQuality={1}
              videoConstraints={videoConstraints}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenWebCamDialog(false);
            }}
            color="primary"
            iconOnly
            circular
            variant="outlined"
          >
            <Icon>close</Icon>
          </Button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <Button
            onClick={() => {
              setCameraUsed(!cameraUsed);
            }}
            color="warning"
            iconOnly
            circular
            variant="outlined"
          >
            <Icon>cameraswitch</Icon>
          </Button>
          &nbsp;
          <Button
            color="info"
            variant="outlined"
            iconOnly
            circular
            onClick={capture}
          >
            <Icon>photo_camera</Icon>
          </Button>
        </DialogActions>
      </Dialog>
      <Box sx={{ minWidth: 120, width: "100%" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} md={6} lg={6}>
            <Typography variant="h6" fontWeight="light" fontSize="small" mb={2}>
              {displayName}
            </Typography>
          </Grid>
          <Grid item xs={6} md={6} lg={6}>
            <Box align="right">
              <IconButton
                color="primary"
                variant="contained"
                iconOnly
                size="small"
                onClick={() => {
                  setUploadType("scan");
                  setImgSrc(null);
                  setCapturedImg(null);
                  setOpenWebCamDialog(true);
                }}
                options={options}
              >
                <Icon>document_scanner</Icon>
              </IconButton>
              &nbsp;
              <IconButton
                color="primary"
                variant="contained"
                size="small"
                onClick={() => {
                  setUploadType("file");
                  setImgSrc(null);
                  setCapturedImg(null);
                  setOpenWebCamDialog(false);
                }}
                options={options}
              >
                <Icon>upload_file</Icon>
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        {uploadType === null ? (
          <> </>
        ) : (
          <Box>
            {uploadType === "scan" ? (
              <Box>
                <Box>
                  {imgSrc ? (
                    <img src={imgSrc} alt="" width="20%" />
                  ) : (
                    <img src={placeholderImg} alt="" width={100} />
                  )}
                </Box>
                <input type="hidden" name={fieldRef} value={capturedImg} />
              </Box>
            ) : (
              <Box>
                <TextField
                  inputProps={{
                    multiple: false,
                    accept:
                      "application/msword, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, text/plain, application/pdf, image/*",
                  }}
                  placeholder={displayName}
                  type="file"
                  onChange={(e) => handleFileChange(e)}
                  options={options}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Icon>article</Icon>
                      </InputAdornment>
                    ),
                  }}
                />
                <input type="hidden" name={fieldRef} value={selectedFile} />
              </Box>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
}

// Typechecking props of the Transaction
DocumentField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

DocumentField.defaultProps = {
  options: null,
};

export default DocumentField;
